import { Whitepaper } from "@/api/types"
import type { Props as CardProps } from '@/components/WhitepaperCard'

export const wpContentModify = (whitepapers: Whitepaper[], basePath: string): CardProps[] => {
  return whitepapers.map((w) => {
    return { title: w.title, eyeCatchingUrl: w.eyeCatching.url, url: `${basePath}/${w.id}` }
  })
}
